import React from 'react';
import { Box, IconButton, Typography } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import CloseIcon from '@material-ui/icons/Close';
import { useStyles } from './styles';

export const Entry = ({ tags, date, title }) => {
  const classes = useStyles();
  return (
    <Box className={classes.entry}>
      <Box className={classes.entryMeta}>
        {tags}
        {date && (
          <Typography component="span" className={classes.entryDate}>
            {date}
          </Typography>
        )}
      </Box>
      <Typography className={classes.entryTitle}>{title}</Typography>
    </Box>
  );
};

export const PreviewPanel = ({ title, subtitle, badge, footer, onClose, children }) => {
  const classes = useStyles();
  return (
    <>
      <Box className={classes.header}>
        <Box className={classes.headerText}>
          <Box className={classes.headerTitleRow}>
            <Typography className={classes.headerTitle}>{title}</Typography>
            {badge}
          </Box>
          {subtitle && (
            <Typography className={classes.headerSubtitle}>{subtitle}</Typography>
          )}
        </Box>
        {onClose && (
          <IconButton className={classes.closeBtn} onClick={onClose} size="small">
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      </Box>

      {children}

      {footer && (
        <Box className={classes.footer} onClick={footer.onClick}>
          <span>{footer.label}</span>
          <ArrowForwardIcon fontSize="small" />
        </Box>
      )}
    </>
  );
};

export default PreviewPanel;
